import type { PatientDetails } from "@/core/types";
import { sharedRequestsTyped } from "@/api/(requests)/sharedTyped";

export async function getPatientDetails(patientId: string): Promise<PatientDetails> {
  const response = await sharedRequestsTyped.fetch_patient_details({
    context: { showLoader: false },
    urlParams: { patientId },
  });

  return response.user;
}
